import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDateTime, asLabel, column, createdByField, field, lastModifiedByField, type Row, related, text } from './kit';

const def = OBJECT_DEFS['billing-policies'];

/** A family of products' billing options. Rationale: billing-policies.md. */
export const billingPolicies: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Billing policy',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('name', 'Name'),
    field('active', 'Active', { format: asCheck }),
    field('description', 'Description', { wide: true }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['name', 'active'] },
    { key: 'description', label: 'Description', fields: ['description'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [
    related('treatments', 'Treatments', 'billing-treatments', [
      column('name', 'Treatment', { primary: true }),
      column('method', 'Method', { format: asLabel }),
      column('billing_frequency', 'Frequency', { format: asLabel }),
      column('is_default', 'Default'),
    ]),
    related('products', 'Products Using It', 'products', [
      column('name', 'Product', { primary: true }),
      column('status', 'Status', { format: asLabel }),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['name'],
};
